import Overview from './Overview';
import Settings from './Settings';
import Teams from './Teams';
import Muted from './Muted';

export default { Overview, Settings, Teams, Muted };
